/**
 * Frontend Script
 */

jQuery(document).ready(function ($) {



    /**
     * Update contents on page based on target group after page load
     */
    // update_page();


    /**
    * Update topics when target group is selected
    */
    $('select#targetgroup').on('change', function (e) {
        $(this).parents('.wp-block-custom-blocks-relevant-topics').addClass('loading');
        update_select_fields($(this));
        update_keyvisual($(this));
    });


    /**
     * Update keyvisual when target group is selected
     */
    function update_keyvisual(elem) {

        var group_id = parseInt(elem.val());

        if (group_id == 0 || typeof group_id === 'undefined' || isNaN(group_id)) {
            jQuery('.keyvisual-item picture').not('[data-group]').fadeIn(200);
        }

        jQuery('.keyvisual-item picture[data-group]').fadeOut(200);
        jQuery('.keyvisual-item picture[data-group=' + group_id + ']').fadeIn(200);

    }


    /**
    * Update select fields
    */
    function update_select_fields(elem) {

        /**
        * Set vars
        */
        var group_id = parseInt(elem.val());
        var parent = elem.closest('.wp-block-custom-blocks-relevant-topics');
        var topic_select = parent.find('select#relevanttopic');

        /**
        * Update local storage
        */
        update_local_storage(group_id);

        /**
         * Enable / disable topic select field
         */
        if (group_id) {
            topic_select.prop('disabled', false);
        } else {
            topic_select.prop('disabled', true);
        }

        /**
         *  Get relevant topics per Ajax
         */
        $.ajax({
            type: 'POST',
            url: CustomBlocks.ajaxurl,
            data: {
                action: 'fetch_relevant_topics',
                ajaxnonce: CustomBlocks.ajaxnonce,
                group: group_id,
            },
            success: function (data, textStatus, XMLHttpRequest) {

                // remove loading
                parent.removeClass('loading');

                // remove options except the placeholder
                topic_select.children().not(':first-child').remove();

                // parse json data
                data = JSON.parse(data);

                // append new options
                Object.entries(data).forEach(entry => {
                    const [key, item] = entry;
                    topic_select.append('<option value="' + item['link'] + '">' + item['title'] + '</option>');
                });

                // refresh simpleselect in case it is used
                try {
                    topic_select.simpleselect("refreshContents");
                    topic_select.simpleselect("refreshState");
                } catch (errorThrown) { return; }
              
                /**
                 * Update postarchive blocks
                 */
                update_postarchives(group_id);

            },
            error: function (MLHttpRequest, textStatus, errorThrown) {
                console.log(errorThrown);
            }
        });

   

    }


    /**
     * Update page if target group in local storage is set
     */
    function update_page() {

        var userData = JSON.parse(localStorage.getItem('user_data'));

        // return directly if userData is null
        if (!userData) return;

        // return directly if group is not set
        if (typeof userData.group === 'undefined') return;

        // update value in select field
        $('select#targetgroup').each(function () {
            $(this).val(userData.group);
            update_select_fields($(this));
        });

        // refresh simpleselect in case it is used
        try {
            $('select#targetgroup').simpleselect("refreshContents");
            $('select#targetgroup').simpleselect("refreshState");
        } catch (errorThrown) {
            return;
        }

        // update all postarchives
        update_postarchives(userData.group);

    }


    /**
     * Follow link when topic is selected
     */
    $('select#relevanttopic').on('click change', function () {

        if (!$(this).val()) return;

        window.location = $(this).val();
    })




    /*
     * Update postarchive blocks
     */
    function update_postarchives(group_id) {
        $('.postarchive').each(function () {

            // get data-atts from postarchive container
            $data_attributes = JSON.parse($(this).attr('data-atts'));

            // set targetgroup
            if (group_id) {
                $data_attributes['targetgroup'] = group_id;
            } else {
                delete $data_attributes['targetgroup'];
            }

            // update data-atts on container
            $(this).attr('data-atts', JSON.stringify($data_attributes));

            // fetch data
            fetch_postarchive_data($data_attributes, $(this).find('.posts'));
        });
    }


    /**
     * Update local storage
     */
    function update_local_storage(group_id) {

        var userData = {};
        if (typeof localStorage.user_data !== 'undefined') {
            userData = JSON.parse(localStorage.getItem('user_data'));
        }
        userData.group = group_id;
        localStorage.setItem('user_data', JSON.stringify(userData));

    }


    /**
     * Update session
     */
    function update_session(group_id) {

        $.ajax({
            type: 'POST',
            url: CustomBlocks.ajaxurl,
            data: {
                action: 'set_targetgroup_session',
                ajaxnonce: CustomBlocks.ajaxnonce,
                group: group_id,
            }
        });

    }


    /**
     * Fetch postarchive data
     */
    function fetch_postarchive_data($data_attributes, $output) {

        $.ajax({
            type: 'POST',
            url: CustomBlocks.ajaxurl,
            data: {
                action: 'data_fetch',
                ajaxnonce: CustomBlocks.ajaxnonce,
                attributes: $data_attributes,
            },
            success: function (data, textStatus, XMLHttpRequest) {
                $output.html(data);
            },
            error: function (MLHttpRequest, textStatus, errorThrown) {
                console.log(errorThrown);
            }
        });

    }

});



// WEBPACK FOOTER //
// ./src/blocks/relevant-topics/js/script.js